import { OPEN_STATE } from './SignInPromptActionType'

export function openstateHandler(value) {
  return {
    type: OPEN_STATE,
    payload: {
      openState: value,
    },
  }
}
